/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, Paper, Typography, styled } from "@mui/material";

export const GlobalDetailsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const SectionTitle = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "16px",
  fontWeight: 600,
});

export const SectionCard = styled(Paper)({
  border: "1px solid #e0e0e0",
  borderRadius: "12px",
  boxShadow: "none",
  overflow: "hidden",
});

export const SectionHeader = styled(Box)({
  backgroundColor: "#fafafa",
  borderBottom: "1px solid #e0e0e0",
  padding: "10px 14px",
});

export const SectionHeaderTitle = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "14px",
  fontWeight: 600,
});

export const SectionBody = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  padding: "12px 14px",
});

export const ColorSummary = styled(Box)({
  alignItems: "center",
  display: "flex",
  gap: "12px",
});

export const ColorSwatch = styled(Box)({
  border: "1px solid rgba(0, 0, 0, 0.12)",
  borderRadius: "999px",
  flexShrink: 0,
  height: "18px",
  width: "18px",
});

export const ValueText = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "14px",
  wordBreak: "break-word",
});

export const EmptyState = styled(Typography)({
  color: "rgba(112, 112, 112, 1)",
  fontSize: "14px",
  fontStyle: "italic",
});

export const CategoryCard = styled(Paper)({
  border: "1px solid #e0e0e0",
  borderRadius: "10px",
  boxShadow: "none",
  overflow: "hidden",
});

export const CategoryHeader = styled(Box)({
  backgroundColor: "#f8fafc",
  borderBottom: "1px solid #e0e0e0",
  padding: "10px 14px",
});

export const CategoryTitle = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "14px",
  fontWeight: 600,
});

export const RowHeader = styled(Box)({
  backgroundColor: "#fcfcfd",
  borderBottom: "1px solid #e0e0e0",
  display: "grid",
  gap: "12px",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  padding: "10px 14px",
  "@media (max-width: 720px)": {
    gridTemplateColumns: "1fr",
  },
});

export const RowHeaderText = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "12px",
  fontWeight: 600,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
});

export const Row = styled(Box)({
  borderBottom: "1px solid #e0e0e0",
  display: "grid",
  gap: "12px",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  padding: "10px 14px",
  "&:last-of-type": {
    borderBottom: "none",
  },
  "@media (max-width: 720px)": {
    gridTemplateColumns: "1fr",
  },
});

export const RowValue = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "14px",
  wordBreak: "break-word",
});

export const ContactGroupCard = styled(Paper)({
  border: "1px solid #e0e0e0",
  borderRadius: "10px",
  boxShadow: "none",
  overflow: "hidden",
});

export const ContactMethodRow = styled(Box)({
  borderBottom: "1px solid #e0e0e0",
  display: "grid",
  gap: "12px",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  padding: "10px 14px",
  "&:last-of-type": {
    borderBottom: "none",
  },
  "@media (max-width: 720px)": {
    gridTemplateColumns: "1fr",
  },
});

export const ExclusionGroup = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

export const ExclusionCategory = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "14px",
  fontWeight: 600,
});

export const ExclusionItem = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "14px",
});
